import React from 'react';
import {Accordion, Card, Button} from 'react-bootstrap';


class NewsCollapse extends React.Component {
  hasImage = (image) => typeof image === 'string' && image.trim().length > 0

  resolveImageUrl = (image) => {
    if (!image) {
      return image;
    }

    if (
      image.startsWith('http://') ||
      image.startsWith('https://') ||
      image.startsWith('//')
    ) {
      return image;
    }

    return `https://d1aummmer0n4kg.cloudfront.net/media/${image.replace(/^\/+/, '')}`;
  }

  render() {
    return (
      <>
        <Accordion defaultActiveKey="0">
          <Card className="white">
            <Card.Header>
              <Accordion.Toggle as={Button} variant="link" eventKey={this.props.id}>
                {this.props.title}
                <span className="timestamp">{this.props.timestamp}</span>
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey={this.props.id}>
              <Card.Body>
                {this.hasImage(this.props.image) ? <img className="news_image" src={this.resolveImageUrl(this.props.image)} alt="news"/> : ''}
                {this.props.content}
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </>
    )
  }
}

export default NewsCollapse;
